
import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { MortgageData } from "../../CalculatorTabs";
import { AutoCalculateOptions } from "../../utils/types";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";

interface FundingFeeToggleProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
  label: string;
  tooltipContent: string;
}

const FundingFeeToggle: React.FC<FundingFeeToggleProps> = ({
  mortgageData,
  setMortgageData,
  autoCalculate,
  label,
  tooltipContent
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <Label htmlFor="roll-funding-fee" className="text-sm font-medium mr-2">
          {label}
        </Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <InfoIcon className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent className="w-80 p-3">
              <p>{tooltipContent}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <Switch
        id="roll-funding-fee"
        checked={mortgageData.rollFundingFeeIntoLoan}
        onCheckedChange={(checked) => {
          setMortgageData(prev => {
            const updatedData = {
              ...prev,
              rollFundingFeeIntoLoan: checked
            };
            return calculateMortgageData(updatedData);
          });
        }}
      />
    </div>
  );
};

export default FundingFeeToggle;
